// permission-route-map.ts

import { PERMISSIONS_TRACER } from "./permissions-tracer.constants";

export const PERMISSION_ROUTE_MAP_TRACER = [
  {
    permission: PERMISSIONS_TRACER.REP.VIEW,
    route: '/tracer'  // or '/tracer/relief-employee-profiles'
  },
  {
    permission: PERMISSIONS_TRACER.BOOKINGS.VIEW,
    route: '/tracer/bookings'   // ✅ FIXED
  },
  {
    permission: PERMISSIONS_TRACER.MANAGE_TEAM.VIEW,
    route: '/tracer/manage-team'
  },  
  {
    permission: PERMISSIONS_TRACER.LEAVE_APPROVAL,
    route: '/tracer/leave-approval'
  },
  {
    permission: PERMISSIONS_TRACER.MY_SCHOOLS.VIEW,
    route: '/tracer/my-schools'
  }

];